import { render, staticRenderFns } from "./modalAccessMpr.vue?vue&type=template&id=97e266d0&scoped=true"
import script from "./modalAccessMpr.vue?vue&type=script&lang=js"
export * from "./modalAccessMpr.vue?vue&type=script&lang=js"
import style0 from "./modalAccessMpr.vue?vue&type=style&index=0&id=97e266d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e266d0",
  null
  
)

export default component.exports